function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.8409 21.4107C29.8409 19.2639 31.4288 17.8328 33.4005 17.8328C33.9192 17.8221 34.4332 17.934 34.9006 18.1593C35.3679 18.3845 35.7755 18.7168 36.0901 19.1292L35.4025 19.5505C35.1618 19.252 34.8567 19.0116 34.5101 18.8473C34.1634 18.6829 33.7841 18.5989 33.4005 18.6015C31.8809 18.6015 30.7412 19.7612 30.7412 21.4107C30.7412 23.0601 31.8923 24.2313 33.4005 24.2313C34.0918 24.2263 34.7556 23.9598 35.2582 23.4853V22.075H32.88V21.3158H36.1205V23.8156C35.7779 24.1961 35.3581 24.4993 34.8891 24.7052C34.4201 24.9111 33.9127 25.0148 33.4005 25.0095C31.4288 25 29.8409 23.5574 29.8409 21.4107Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M43.4979 24.8652L41.7333 22.1168H40.3524V24.8652H39.4919V17.9466H42.2633C43.5283 17.9466 44.4325 18.7552 44.4325 20.0345C44.4325 21.2797 43.5815 21.9649 42.6375 22.0484L44.5066 24.8652H43.4979ZM43.5492 20.0307C43.5492 19.2525 42.9889 18.7135 42.1683 18.7135H40.3524V21.3594H42.1683C42.9794 21.3594 43.5397 20.809 43.5397 20.0307H43.5492Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M47.1963 21.4107C47.1963 19.3607 48.5753 17.8422 50.6305 17.8422C52.6858 17.8422 54.0667 19.3778 54.0667 21.4202C54.0667 23.4625 52.6763 24.9981 50.6305 24.9981C48.5848 24.9981 47.1963 23.4549 47.1963 21.4107ZM53.1739 21.4107C53.1739 19.7935 52.1767 18.6015 50.6305 18.6015C49.0844 18.6015 48.089 19.7935 48.089 21.4107C48.089 23.0279 49.0749 24.2218 50.6305 24.2218C52.1862 24.2218 53.1739 23.0184 53.1739 21.4107Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M56.7563 22.1794V17.9466H57.6168V22.1566C57.6168 23.4227 58.3025 24.2218 59.5789 24.2218C60.8554 24.2218 61.543 23.4227 61.543 22.1566V17.9466H62.4035V22.168C62.4035 23.8896 61.4537 24.9886 59.5808 24.9886C57.708 24.9886 56.7563 23.8782 56.7563 22.1794Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M65.8283 24.8652V17.9466H68.6111C70.0015 17.9466 70.7803 18.8957 70.7803 20.0345C70.7803 21.1734 69.9825 22.1225 68.6111 22.1225H66.6907V24.8652H65.8283ZM69.8875 20.0307C69.8875 19.2525 69.3272 18.7135 68.5066 18.7135H66.6907V21.348H68.5066C69.331 21.348 69.8875 20.809 69.8875 20.0307Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.58636 0H0V5.58234H5.58636V0Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0646 12.5085L8.22284 0H11.262L14.7361 9.62152L18.1875 0H21.2267L16.4058 12.5085H13.0646Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2085 12.5085L25.2404 4.34667V12.5085H22.5811V0H25.3221L31.1136 7.85817V0H33.7728V12.5085H31.2085Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M38.7759 12.5085V2.34417H35.1176V0H45.1012V2.34417H41.4599V12.5085H38.7759Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M53.4931 12.5085L51.0352 8.06507H49.0825V12.5085H46.4232V0H52.2774C54.8873 0 56.4829 1.7083 56.4829 4.03158C56.4829 6.24478 55.0925 7.4273 53.7419 7.74618L56.5532 12.5085H53.4931ZM53.7552 4.03158C53.7552 2.98193 52.948 2.34417 51.8785 2.34417H49.0825V5.719H51.8785C52.948 5.719 53.7552 5.08314 53.7552 4.03158Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M67.192 12.5085L66.4227 10.3903H61.0548L60.2646 12.5085H57.2255L62.0672 0H65.4084L70.2331 12.5085H67.192ZM63.7369 2.65735L61.7861 8.04609H65.6895L63.7369 2.65735Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M73.0578 12.5085L68.216 0H71.2552L74.7255 9.62152L78.1826 0H81.2217L76.3971 12.5085H73.0578Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M82.4924 12.5085V0H91.3515V2.34417H85.1573V4.98823H91.2205V7.3324H85.1573V10.1644H91.3515V12.5085H82.4924Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M94.0412 12.5085V0H96.7004V10.1644H102.002V12.5085H94.0412Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M0.25 12.2585V7.17612H5.33636V12.2585H0.25Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.5
});

var SvgIcLogoBanner = function SvgIcLogoBanner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 26,
    viewBox: "0 0 103 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcLogoBanner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_logoBanner.163bd074.svg";
export { ForwardRef as ReactComponent };